export const IS_NEWS_LOADING = "IS_NEWS_LOADING";
export const GET_NEWS = "GET_NEWS";
